import { ON_CONVERSATION_MERGED_EVENT_TYPE } from 'core/constants';
import { runListenersForEvent } from 'core_main/globals/events';
import {
  ConversationMergedCallbackResponse,
  PubNubChatSessionMergedMessageEvent,
} from '../types';

export const createChatSessionMergedCallbackResponse = (
  event: PubNubChatSessionMergedMessageEvent,
): ConversationMergedCallbackResponse => {
  const { data } = event;
  const { relationships } = data;
  const { source, target } = relationships;
  const { id: sourceId } = source.data;
  const { id: targetId } = target.data;

  return {
    sourceConversationId: sourceId,
    targetConversationId: targetId,
  };
};

export const handleChatSessionMergedEvent = (
  message: PubNubChatSessionMergedMessageEvent,
) => {
  const callbackResponse = createChatSessionMergedCallbackResponse(message);

  runListenersForEvent(ON_CONVERSATION_MERGED_EVENT_TYPE, callbackResponse);
};
